import React, {useRef,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next" 
import { ENDPOINT } from "constants/variables";
import IconButton from '@mui/material/IconButton'; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import TypesDISearchStores from "./TypesDISearchStores";
import TypesDISearchStoresAddress from "./TypesDISearchStoresAddress";
import TypesDISearchStoresNimaAddresses from "pages/typesDIFormat/typesDIEdit/TypesDISearchStoresNimaAddress";
import TypesDISearchVehicles from "./TypesDISearchVehicles";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const TypeDICreateOrEditAutTras = ({formForm,setFormForm,errorsForm,setErrorsForm,validateForm,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect}) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);     
    const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false); 
    const dispatch = useDispatch(); 
    const [postalCodeAutToSelect,setPostalCodeAutToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeAut, setFilteredpostalCodeAut] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeAut, setHighlightedIndexPostalCodeAut] = useState(-1); // Índice de la opción resaltada 
    const [documentIdAutToSelect,setDocumentIdAutToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdAut, setFilteredDocumentIdAut] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdAut, setHighlightedIndexDocumentIdAut] = useState(-1); // Índice de la opción resaltada 
    const [tradenameAutToSelect,setTradenameAutToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedAut, setFilteredTradenamedAut] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedAut, setHighlightedIndexTradenamedAut] = useState(-1); // Índice de la opción resaltada 
    const [autTrasNimaToSelect,setAutTrasNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredAutTrasNima, setFilteredAutTrasNima] = useState([]); // Opciones filtradas
    const [highlightedIndexAutTrasNima, setHighlightedIndexAutTrasNima] = useState(-1); // Índice de la opción resaltada 
      
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
        
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeAut([]);
            setHighlightedIndexPostalCodeAut(-1);
        return;
        }
        const filtered = postalCodeAutToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeAut(filtered);
        setHighlightedIndexPostalCodeAut(0);
    }, 300); 
    const handleSelectPostalCodeAut = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            default_aut_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            default_aut_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            default_aut_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            default_aut_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeAut([]);
        setHighlightedIndexPostalCodeAut(-1);
    }; 
    const handleKeyDownDPostalCodeAut = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeAut.length === 0 && formForm.default_aut_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeAut(postalCodeAutToSelect);
            setHighlightedIndexPostalCodeAut(0);
        } else {
            setHighlightedIndexPostalCodeAut((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeAut.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeAut((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeAut >= 0) {
            if (highlightedIndexPostalCodeAut >= 0 && highlightedIndexPostalCodeAut < filteredpostalCodeAut.length) {
                handleSelectPostalCodeAut(filteredpostalCodeAut[highlightedIndexPostalCodeAut]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeAutToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.default_aut_tras_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm,
                default_aut_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                default_aut_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                default_aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                default_aut_tras_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeAut([]);
        setHighlightedIndexPostalCodeAut(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdAut([]);
            setHighlightedIndexDocumentIdAut(-1);
            return;
        }
        const filtered = documentIdAutToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdAut(filtered);
        setHighlightedIndexDocumentIdAut(0);
    }, 300);
    const handleSelectDocumentIdAut = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            default_aut_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdAut([]);
        setHighlightedIndexDocumentIdAut(-1);
    }; 
    const handleKeyDownDocumentIdAut = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdAut.length === 0 && formForm.default_aut_tras_documentid.trim() === "") {
            setFilteredDocumentIdAut(documentIdAutToSelect);
            setHighlightedIndexDocumentIdAut(0);
        } else {
            setHighlightedIndexDocumentIdAut((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdAut.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdAut((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdAut >= 0) {
        if (highlightedIndexDocumentIdAut >= 0 && highlightedIndexDocumentIdAut < filteredDocumentIdAut.length) {
            handleSelectDocumentIdAut(filteredDocumentIdAut[highlightedIndexDocumentIdAut]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdAutToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.default_aut_tras_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            default_aut_tras_documentid: "",
            }));
        } 
        setFilteredDocumentIdAut([]);
        setHighlightedIndexDocumentIdAut(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedAut([]);
            setHighlightedIndexTradenamedAut(-1);
        return;
        }
        const filtered = tradenameAutToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedAut(filtered);
        setHighlightedIndexTradenamedAut(0);
    }, 300); 
    const handleSelectTradeNameAut = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        default_aut_tras_tradename: store.tradename || "",
        default_aut_tras_documentid: store.documentid || formForm.default_aut_tras_documentid,
        
        }));
        setFilteredTradenamedAut([]);
        setHighlightedIndexTradenamedAut(-1);
    }; 
    const handleKeyDownTradenameAut = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedAut.length === 0 && formForm.default_aut_tras_tradename.trim() === "") {
            setFilteredTradenamedAut(tradenameAutToSelect);
            setHighlightedIndexTradenamedAut(0);
        } else {
            setHighlightedIndexTradenamedAut((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedAut.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedAut((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedAut >= 0) {
        if (highlightedIndexTradenamedAut >= 0 && highlightedIndexTradenamedAut < filteredTradenamedAut.length) {
            handleSelectTradeNameAut(filteredTradenamedAut[highlightedIndexTradenamedAut]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameAutToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formForm.default_aut_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            default_aut_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedAut([]);
        setHighlightedIndexTradenamedAut(-1);
        }
    }; 

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    // Dentro del componente
    const debouncedHandleSearchAutTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredAutTrasNima([]);
            setHighlightedIndexAutTrasNima(-1);
        return;
        }
        const filtered = autTrasNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredAutTrasNima(filtered);
        setHighlightedIndexAutTrasNima(0);
    }, 300); 
    const handleSelectAutTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        default_aut_tras_nima: nt.nima || ""
        }));
        setFilteredAutTrasNima([]);
        setHighlightedIndexAutTrasNima(-1);
    }; 
    const handleKeyDownAutTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredAutTrasNima.length === 0 && formForm.default_aut_tras_nima.trim() === "") {
                const filtered = autTrasNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredAutTrasNima(filtered);
                setHighlightedIndexAutTrasNima(0);
            } else {
                setHighlightedIndexAutTrasNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredAutTrasNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexAutTrasNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexAutTrasNima >= 0) {
            if (highlightedIndexAutTrasNima >= 0 && highlightedIndexAutTrasNima < filteredAutTrasNima.length) {
                handleSelectAutTrasNima(filteredAutTrasNima[highlightedIndexAutTrasNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = autTrasNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.default_aut_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm, 
                default_aut_tras_nima: ""
            }));
        } 
        setFilteredAutTrasNima([]);
        setHighlightedIndexAutTrasNima(-1);
        }
    };

    const handleBlur = useCallback((event) => {
            if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeAut([]);
            setHighlightedIndexPostalCodeAut(-1);
            setFilteredDocumentIdAut([]);
            setHighlightedIndexDocumentIdAut(-1);
            setFilteredTradenamedAut([]);
            setHighlightedIndexTradenamedAut(-1);  
            setFilteredAutTrasNima([]);
            setHighlightedIndexAutTrasNima(-1);  
        }
    }, []);

    const handleChangeSelectDocumentType_Aut_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            default_aut_tras_documnettype_id:event.target.value
        }));
    };
    const handleBlurSelectDocumentType_Aut_Tras = (e) => {
        handleChangeSelectDocumentType_Aut_Tras(e);
    };
    
    const handleChangeSelectRoadType_Aut_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            default_aut_tras_roadtype_id : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Aut_Tras = (e) => {
        handleChangeSelectRoadType_Aut_Tras(e);
        setErrorsForm(validateForm());
    };
     
    const handleChangeSelectCommunity_Aut_Tras = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            default_aut_tras_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Aut_Tras = (e) => {
        handleChangeSelectCommunity_Aut_Tras(e);
        setErrorsForm(validateForm());
    };

    const handleChangeDataEditForm_Aut_Tras = (e) => {
        const { name, value } = e.target;
        setFormForm(formForm => ({
          ...formForm,
          [name]: value,
        }));
    };
    
    const handleBlurDataEditForm_Aut_Tras = (e) => {
        handleChangeDataEditForm_Aut_Tras(e);
        setErrorsForm(validateForm());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };

    const searchFormVehicles = (event) => {
        setShowModalSearchVehicles(true);
    };

    const deleteDateAutTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            default_aut_tras_id:0,
            default_aut_tras_documnettype_id: "",
            default_aut_tras_documentid:"",
            default_aut_tras_tradename: "",
            default_aut_tras_name: "",
            default_aut_tras_contactname: "",
            default_aut_tras_roadtype_id: Number(DEFAULTROADTYE),
            default_aut_tras_street: "",
            default_aut_tras_country_id: Number(DEFAULTCOUNTRY),
            default_aut_tras_country_name:DEFAULTCOUNTRY_NAME,
            default_aut_tras_province_id: Number(DEFAULTPROVINCE),
            default_aut_tras_province_name:DEFAULTPROVINCE_NAME,
            default_aut_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            default_aut_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            default_aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            default_aut_tras_community_id: Number(DEFAULTCOMMUNITY),
            default_aut_tras_community_name: DEFAULTCOMMUNITY_NAME,
            default_aut_tras_phone: "",
            default_aut_tras_email: "",
            default_aut_tras_nima: "",
            default_aut_tras_cnae: "",
            default_aut_tras_inscription: "",
            default_aut_tras_opt: 0,
            default_aut_tras_licenseplate: "",
            default_aut_tras_economicactivity:""
        }));
        setErrorsForm(validateForm()); 
    };

    const deleteDataSteetAutTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            default_aut_tras_roadtype_id: Number(DEFAULTROADTYE),
            default_aut_tras_street: "",
            default_aut_tras_country_id: Number(DEFAULTCOUNTRY),
            default_aut_tras_country_name:DEFAULTCOUNTRY_NAME,
            default_aut_tras_province_id: Number(DEFAULTPROVINCE),
            default_aut_tras_province_name:DEFAULTPROVINCE_NAME,
            default_aut_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
            default_aut_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            default_aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            default_aut_tras_community_id: Number(DEFAULTCOMMUNITY),
            default_aut_tras_community_name: DEFAULTCOMMUNITY_NAME,
            default_aut_tras_nima: "",
            default_aut_tras_opt: 0,
            default_aut_tras_inscription: ""
        }));
        setErrorsForm(validateForm());
    };

    const deleteDataVehicleAutTras = (event) => {
        setFormForm(formForm => ({
          ...formForm,
          default_aut_tras_licenseplate: ""
        }));
        setErrorsForm(validateForm());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`typesdi/getexiststorebynumberdocument/`,token,formForm.default_aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formForm.default_aut_tras_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
              const getData = await helpHttp().get5(ENDPOINT,`typesdi/getformstorebynumberdocument`,token,formForm.default_aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim(),3);
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData!==undefined && getData!==null && getData!==""){
                    setFormForm(formForm => ({
                        ...formForm,
                        default_aut_tras_id: getData.store_id,
                        default_aut_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                        default_aut_tras_tradename: getData.tradename,
                        default_aut_tras_name: getData.name,
                        default_aut_tras_contactname: getData.contacperson,
                        default_aut_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                || getData.roadtype_id===null  
                                                || getData.roadtype_id===""
                                                || getData.roadtype_id==="0"
                                                || getData.roadtype_id===0)?
                                                Number(DEFAULTROADTYE):getData.roadtype_id,
                        default_aut_tras_street: getData.street,
                        default_aut_tras_country_id: (getData.country_id===undefined 
                                                || getData.country_id===null  
                                                || getData.country_id===""
                                                || getData.country_id==="0"
                                                || getData.country_id===0)?
                                                Number(DEFAULTCOUNTRY):getData.country_id,
                        default_aut_tras_country_name: (getData.country_name===undefined 
                                                || getData.country_name===null  
                                                || getData.country_name==="" )?
                                                DEFAULTCOUNTRY_NAME:getData.country_name,
                        default_aut_tras_province_id: (getData.province_id===undefined 
                                                || getData.province_id===null  
                                                || getData.province_id===""
                                                || getData.province_id==="0"
                                                || getData.province_id===0)?
                                                Number(DEFAULTPROVINCE):getData.province_id,
                        default_aut_tras_province_name: (getData.province_name===undefined 
                                                || getData.province_name===null  
                                                || getData.province_name==="" )?
                                                DEFAULTPROVINCE_NAME:getData.province_name, 
                        default_aut_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                    || getData.postalcode_id===null  
                                                    || getData.postalcode_id===""
                                                    || getData.postalcode_id==="0"
                                                    || getData.postalcode_id===0)?
                                                    Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                        default_aut_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                    || getData.postalcode_code===null  
                                                    || getData.postalcode_code==="" )?
                                                        DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                        default_aut_tras_postalcode_name:(getData.postalcode_name===undefined 
                                                    || getData.postalcode_name===null  
                                                    || getData.postalcode_name==="" )?
                                                        DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                        default_aut_tras_community_id: (getData.community_id===undefined 
                                                    || getData.community_id===null  
                                                    || getData.community_id===""
                                                    || getData.community_id==="0"
                                                    || getData.community_id===0)?
                                                    Number(DEFAULTCOMMUNITY):getData.community_id,
                        default_aut_tras_community_name:(getData.community_name===undefined 
                                                    || getData.community_name===null  
                                                    || getData.community_name==="" )?
                                                        DEFAULTCOMMUNITY_NAME:getData.community_name,  
                        default_aut_tras_phone: getData.phone,
                        default_aut_tras_email: getData.email,
                        default_aut_tras_nima: getData.nima_aut_tras,
                        default_aut_tras_cnae: getData.cnae,
                        default_aut_tras_inscription: getData.pygr_aut_tras,
                        default_aut_tras_opt: getData.opt_aut_tras,
                        default_aut_tras_licenseplate: getData.licenseplate,
                        default_aut_tras_economicactivity:getData.economicactivity
                    }));
                }  
            }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formForm.default_aut_tras_documentid && formForm.default_aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            } 
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formForm.default_aut_tras_documentid,errorsForm.default_aut_tras_documentid,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,DEFAULTPROVINCE,setFormForm,formForm.default_aut_tras_id,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
     
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdAut = async () => {
            try {
            const getData = await helpHttp().get2(ENDPOINT,`typesdi/getlistdocumentidtypesdi/`,token,
                (formForm.default_aut_tras_documentid!==undefined && formForm.default_aut_tras_documentid!==null && formForm.default_aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setDocumentIdAutToSelect(getData); 
            }
            } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formForm.default_aut_tras_documentid && formForm.default_aut_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdAut();
            }
        } else{
            setDocumentIdAutToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.default_aut_tras_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameAut = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`typesdi/getlisttradenametypesdi/`,token,
                    (formForm.default_aut_tras_tradename!==undefined && formForm.default_aut_tras_tradename!==null && formForm.default_aut_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameAutToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formForm.default_aut_tras_tradename && formForm.default_aut_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameAut();
            }
        } else{
            setTradenameAutToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.default_aut_tras_tradename,expanded]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAut = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlistpostalcodeformdi/`,token,
                    (formForm.default_aut_tras_postalcode_code!==undefined && formForm.default_aut_tras_postalcode_code!==null && formForm.default_aut_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeAutToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formForm.default_aut_tras_postalcode_code && formForm.default_aut_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAut();
            } 
        } else{
            setPostalCodeAutToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.default_aut_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormForm]);

     useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaAutTras = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchtypesdi/getlistnimas`,token,formForm.default_aut_tras_id, 
                    (formForm.default_aut_tras_nima!==undefined && formForm.default_aut_tras_nima!==null && formForm.default_aut_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.default_aut_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setAutTrasNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3'){
            if (formForm.default_aut_tras_id && formForm.default_aut_tras_id!==null && formForm.default_aut_tras_id!=="" && formForm.default_aut_tras_id!=="0" && formForm.default_aut_tras_id!==0){
                fetchDataNimaAutTras(); 
            }else{
                setAutTrasNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm,expanded,setFormForm,formForm.default_aut_tras_id]);

    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel3') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="default_aut_tras_documnettype_id"
                        name="default_aut_tras_documnettype_id"
                        value={ (formForm.default_aut_tras_documnettype_id === undefined || formForm.default_aut_tras_documnettype_id ===null || formForm.default_aut_tras_documnettype_id ===""
                            || formForm.default_aut_tras_documnettype_id ==="0" || formForm.default_aut_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formForm.default_aut_tras_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectDocumentType_Aut_Tras}
                        onChange={handleChangeSelectDocumentType_Aut_Tras}
                        helperText={errorsForm.default_aut_tras_documnettype_id!=null && errorsForm.default_aut_tras_documnettype_id!==""?t(errorsForm.default_aut_tras_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_tras_documnettype_id === undefined || formForm.default_aut_tras_documnettype_id ===null || formForm.default_aut_tras_documnettype_id ===""
                                || formForm.default_aut_tras_documnettype_id ==="0" || formForm.default_aut_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formForm.default_aut_tras_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_tras_documentid"
                            name="default_aut_tras_documentid"
                            value={formForm.default_aut_tras_documentid}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                    ...prev,
                                    default_aut_tras_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDocumentIdAut}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.default_aut_tras_documentid!=null && errorsForm.default_aut_tras_documentid!==""?t(errorsForm.default_aut_tras_documentid):t('PlaceHolder_FORM_CIF')}
                            placeholder={t('PlaceHolder_FORM_CIF')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        /> 
                        {/* Desplegable dinámico */}
                        {filteredDocumentIdAut.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "400px",
                                overflowY: "auto",
                                width: "250%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                            {filteredDocumentIdAut.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectDocumentIdAut(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdAut ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdAut ? "white" : "black",
                                    }}
                                >
                                    {store.documentid} - {store.tradename}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>  
                     &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateAutTras}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className="edit-select-button" onClick={searchFormStore}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_tras_tradename"
                            name="default_aut_tras_tradename"
                            value={formForm.default_aut_tras_tradename}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                    ...prev,
                                    default_aut_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameAut}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.default_aut_tras_tradename!=null && errorsForm.default_aut_tras_tradename!==""?t(errorsForm.default_aut_tras_tradename):t('PlaceHolder_FORM_TRADENAME')}
                            placeholder={t('PlaceHolder_FORM_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedAut.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedAut.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameAut(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedAut ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedAut ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NAME')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="default_aut_tras_name" 
                    name="default_aut_tras_name"
                    value={formForm.default_aut_tras_name}
                    inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    label={errorsForm.default_aut_tras_name!=null && errorsForm.default_aut_tras_name!==""?t(errorsForm.default_aut_tras_name):t('PlaceHolder_FORM_NAME')}
                    placeholder={t('PlaceHolder_FORM_NAME')}
                    variant="standard"
                    onBlur={handleBlurDataEditForm_Aut_Tras}
                    onChange={handleChangeDataEditForm_Aut_Tras} 
                />
                </div>
            </div> 
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CONTACT')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="default_aut_tras_contactname" 
                    name="default_aut_tras_contactname"
                    value={formForm.default_aut_tras_contactname}
                    inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    label={errorsForm.default_aut_tras_contactname!=null && errorsForm.default_aut_tras_contactname!==""?t(errorsForm.default_aut_tras_contactname):t('PlaceHolder_FORM_CONTACT')}
                    placeholder={t('PlaceHolder_FORM_CONTACT')}
                    variant="standard"
                    onBlur={handleBlurDataEditForm_Aut_Tras}
                    onChange={handleChangeDataEditForm_Aut_Tras} 
                />
                </div>
            </div> 
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_roadtype_id"
                        name="default_aut_tras_roadtype_id"
                        value={ (formForm.default_aut_tras_roadtype_id === undefined || formForm.default_aut_tras_roadtype_id ===null || formForm.default_aut_tras_roadtype_id ===""
                            || formForm.default_aut_tras_roadtype_id ==="0" || formForm.default_aut_tras_roadtype_id ===0)?Number(DEFAULTROADTYE):formForm.default_aut_tras_roadtype_id}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Aut_Tras}
                        onChange={handleChangeSelectRoadType_Aut_Tras} 
                        helperText={errorsForm.default_aut_tras_roadtype_id!=null && errorsForm.default_aut_tras_roadtype_id!==""?t(errorsForm.default_aut_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_tras_roadtype_id === undefined || formForm.default_aut_tras_roadtype_id ===null || formForm.default_aut_tras_roadtype_id ===""
                                || formForm.default_aut_tras_roadtype_id ==="0" || formForm.default_aut_tras_roadtype_id ===0)?Number(DEFAULTROADTYE): formForm.default_aut_tras_roadtype_id
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Address')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_street" 
                        name="default_aut_tras_street"
                        value={formForm.default_aut_tras_street}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_tras_street!=null && errorsForm.default_aut_tras_street!==""?t(errorsForm.default_aut_tras_street):t('PlaceHolder_FORM_Address')}
                        placeholder={t('PlaceHolder_FORM_Address')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataSteetAutTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.default_aut_tras_documentid!==undefined && formForm.default_aut_tras_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formForm.default_aut_tras_id===undefined
                        || formForm.default_aut_tras_id===""
                        || formForm.default_aut_tras_id==="0"
                        || formForm.default_aut_tras_id===0)
                        ? "noselect-button": "select-button" }`}
                        disabled={formForm.default_aut_tras_id===undefined
                        || formForm.default_aut_tras_id===""
                        || formForm.default_aut_tras_id==="0"
                        || formForm.default_aut_tras_id===0}
                        onClick={searchFormStoreAddress}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton> 
                }
            </div>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_tras_postalcode_code"
                            name="default_aut_tras_postalcode_code"
                            value={formForm.default_aut_tras_postalcode_code}
                            onChange={(e) => {
                                    setFormForm(prev => ({
                                    ...prev,
                                    default_aut_tras_postalcode_code: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCode(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeAut}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formForm.default_aut_tras_postalcode_code.trim().toUpperCase();
                                    const matchedPostal = postalCodeAutToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormForm((prev) => ({
                                            ...prev,
                                            default_aut_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            default_aut_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            default_aut_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            default_aut_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormForm((prev) => ({
                                            ...prev,
                                            default_aut_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                            default_aut_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                            default_aut_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                            default_aut_tras_province_id: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeAut([]);
                                    setHighlightedIndexPostalCodeAut(-1);
                                }
                            }}
                            label={errorsForm.default_aut_tras_postalcode_code!=null && errorsForm.default_aut_tras_postalcode_code!==""?t(errorsForm.default_aut_tras_postalcode_code):t('Text_FORM_PostalCode')}
                            placeholder={t('Text_FORM_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeAut.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeAut.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeAut(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeAut ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeAut ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_postalcode_name" 
                        name="default_aut_tras_postalcode_name"
                        value={formForm.default_aut_tras_postalcode_name}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_tras_postalcode_name!=null && errorsForm.default_aut_tras_postalcode_name!==""?t(errorsForm.default_aut_tras_postalcode_name):t('Text_FORM_Locality')}
                        placeholder={t('Text_FORM_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_community_id"
                        name="default_aut_tras_community_id"
                        value={ (formForm.default_aut_tras_community_id === undefined || formForm.default_aut_tras_community_id ===null || formForm.default_aut_tras_community_id ===""
                            || formForm.default_aut_tras_community_id ==="0" || formForm.default_aut_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formForm.default_aut_tras_community_id}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity_Aut_Tras}
                        onChange={handleChangeSelectCommunity_Aut_Tras}
                        helperText={errorsForm.default_aut_tras_community_id!=null  && errorsForm.default_aut_tras_community_id!==""?t(errorsForm.default_aut_tras_community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_tras_community_id === undefined || formForm.default_aut_tras_community_id ===null || formForm.default_aut_tras_community_id ===""
                                || formForm.default_aut_tras_community_id ==="0" || formForm.default_aut_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formForm.default_aut_tras_community_id
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                     <TextField
                        id="default_aut_tras_phone" 
                        name="default_aut_tras_phone"
                        value={formForm.default_aut_tras_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_tras_phone!=null && errorsForm.default_aut_tras_phone!==""?t(errorsForm.default_aut_tras_phone):t('PlaceHolder_FORM_Phone')}
                        placeholder={t('PlaceHolder_FORM_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                    /> 
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="default_aut_tras_email" 
                        name="default_aut_tras_email"
                        value={formForm.default_aut_tras_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.default_aut_tras_email!=null && errorsForm.default_aut_tras_email!==""?t(errorsForm.default_aut_tras_email):t('PlaceHolder_FORM_Email')}
                        placeholder={t('PlaceHolder_FORM_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="default_aut_tras_nima"
                            name="default_aut_tras_nima"
                            value={formForm.default_aut_tras_nima}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                ...prev,
                                default_aut_tras_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchAutTrasNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownAutTrasNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.default_aut_tras_nima!=null && errorsForm.default_aut_tras_nima!==""?t(errorsForm.default_aut_tras_nima):t('PlaceHolder_FORM_NIMA')}
                            placeholder={t('PlaceHolder_FORM_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredAutTrasNima.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredAutTrasNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectAutTrasNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexAutTrasNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexAutTrasNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.default_aut_tras_documentid!==undefined && formForm.default_aut_tras_documentid!=="") ?
                         <IconButton  size="small" className={`edit-${
                            (formForm.default_aut_tras_id===undefined
                            || formForm.default_aut_tras_id===""
                            || formForm.default_aut_tras_id==="0"
                            || formForm.default_aut_tras_id===0
                            )? "noselect-button": "select-button" }`}
                            disabled={formForm.default_aut_tras_id===undefined
                            || formForm.default_aut_tras_id===""
                            || formForm.default_aut_tras_id==="0"
                            || formForm.default_aut_tras_id===0 } 
                            onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    } 
                </div>
            </div> 
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_INSCRIPTION')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_inscription" 
                        name="default_aut_tras_inscription"
                        value={formForm.default_aut_tras_inscription}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: 350,  fontSize: '18px'}, maxLength: 50 }}
                        label={errorsForm.default_aut_tras_inscription!=null && errorsForm.default_aut_tras_inscription!==""?t(errorsForm.default_aut_tras_inscription):t('PlaceHolder_FORM_INSCRIPTION')}
                        placeholder={t('PlaceHolder_FORM_INSCRIPTION')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                    /> 
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_OPT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_opt"
                        name="default_aut_tras_opt"
                        value={ (formForm.default_aut_tras_opt === undefined || formForm.default_aut_tras_opt ===null || formForm.default_aut_tras_opt ===""
                            || formForm.default_aut_tras_opt ==="0" || formForm.default_aut_tras_opt ===0)?0:formForm.default_aut_tras_opt}
                        inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                        helperText={errorsForm.default_aut_tras_opt!=null?t(errorsForm.default_aut_tras_opt):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formForm.default_aut_tras_opt === undefined || formForm.default_aut_tras_opt ===null || formForm.default_aut_tras_opt ===""
                                || formForm.default_aut_tras_opt ==="0" || formForm.default_aut_tras_opt ===0)?0: formForm.default_aut_tras_opt
                        }}>
                        <option key={0} value=""/>
                        {optTypeToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.code} - {option.namees.substring(0,20)}
                        </option>
                        ))}
                    </TextField>    
                </div>
            </div>  
             
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CNAE')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_cnae" 
                        name="default_aut_tras_cnae"
                        value={formForm.default_aut_tras_cnae}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: (i18n.language==='es'?388:399),  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.default_aut_tras_cnae!=null && errorsForm.default_aut_tras_cnae!==""?t(errorsForm.default_aut_tras_cnae):t('PlaceHolder_FORM_CNAE')}
                        placeholder={t('PlaceHolder_FORM_CNAE')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                    />
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                   <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Economicactivity')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_economicactivity" 
                        name="default_aut_tras_economicactivity"
                        value={formForm.default_aut_tras_economicactivity}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: i18n.language==='es'?397:823,  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.default_aut_tras_economicactivity!=null && errorsForm.default_aut_tras_economicactivity!==""?t(errorsForm.default_aut_tras_economicactivity):t('PlaceHolder_FORM_Economicactivity')}
                        placeholder={t('PlaceHolder_FORM_Economicactivity')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Vehicles')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="default_aut_tras_licenseplate" 
                        name="default_aut_tras_licenseplate"
                        value={formForm.default_aut_tras_licenseplate}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        label={errorsForm.default_aut_tras_licenseplate!=null?t(errorsForm.default_aut_tras_licenseplate):t('PlaceHolder_FORM_Vehicles')}
                        placeholder={t('PlaceHolder_FORM_Vehicles')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Aut_Tras}
                        onChange={handleChangeDataEditForm_Aut_Tras} 
                    />
                    &nbsp;&nbsp;
                    <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDataVehicleAutTras}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className={`edit-${
                            (formForm.default_aut_tras_id===undefined
                                    || formForm.default_aut_tras_id===""
                                    || formForm.default_aut_tras_id==="0"
                                    || formForm.default_aut_tras_id===0)? "noselect-button": "select-button" }`}
                            disabled={(formForm.default_aut_tras_id===undefined
                                    || formForm.default_aut_tras_id===""
                                    || formForm.default_aut_tras_id==="0"
                                    || formForm.default_aut_tras_id===0)}  onClick={searchFormVehicles}> 
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>  
                    }
                </div>
            </div>
            <TypesDISearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Aut_Tras"}
                setFormForm={setFormForm}
            />
             <TypesDISearchStoresAddress
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Aut_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.default_aut_tras_tradename}
                store_id={formForm.default_aut_tras_id}
                priority={3}
            />
            <TypesDISearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Aut_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.default_aut_tras_tradename}
                store_id={formForm.default_aut_tras_id} 
            />
            <TypesDISearchVehicles
                showModalSearchVehicles={showModalSearchVehicles}
                setShowModalSearchVehicles={setShowModalSearchVehicles}
                selectStores={"Aut_Tras"}
                setFormForm={setFormForm}
                titleTable={formForm.default_aut_tras_tradename}
                store_id={formForm.default_aut_tras_id}
            />
        </> 
    )
}

TypeDICreateOrEditAutTras.propTypes = {
    formForm: PropTypes.object.isRequired,
    setFormForm: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateForm: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired
  };
  
  export default TypeDICreateOrEditAutTras;

